<div class="main-container">
  <div class="grid-container" id="count-by-business-grid-container" style="height: calc(100vh - 124px);">
    <div class="top-toolbar">
      <div class="toolbar-actions">
        @if (taxyearLoaded) {
          <span class="toolbar-label">Tax Year</span>
          <ap-dropdown class="tax-year-dropdown" [list]="taxYearItems" [selectType]="'single'"
            [title]="'Tax Year'" [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'"
            [(ngModel)]="selectedTaxYearItem" (onSelect)="onTaxYearChanged($event)">
            @for (item of taxYearItems; track item.value) {
              <ap-dropdown-list-item #dropdownListItem [item]="item"
                [ariaLabel]="setTaxYearAriaLabel(item)" (onSelectItem)="onTaxYearSelectItem($event)"></ap-dropdown-list-item>
            }
          </ap-dropdown>
        }

        @if (taxyearLoaded && previousTaxYearItems.length) {
          <span class="toolbar-label">Previous Tax Year</span>
          <ap-dropdown class="tax-year-dropdown" [list]="previousTaxYearItems" [selectType]="'single'"
            [title]="'Previous Tax Year'" [hideTitleOnInput]="true" [inputAriaLabel]="'Previous Tax Year'"
            [(ngModel)]="selectedPreviousTaxYearItem" (onSelect)="onPreviousTaxYearChanged($event)">
            @for (item of previousTaxYearItems; track item.value) {
              <ap-dropdown-list-item #dropdownListItem [item]="item"
                [ariaLabel]="setTaxYearAriaLabel(item)" (onSelectItem)="onPreviousTaxYearSelectItem($event)"></ap-dropdown-list-item>
            }
          </ap-dropdown>
        }

        <span class="toolbar-label">Business Name</span>
        <span class="business-loading-spinner">@if (loading) {
          <i class="fa fa-spin fa-spinner"></i>
        }</span>
          <ap-dropdown class="text-black" [list]="businessDropdownList" [selectType]="'multiple'"
            [enableNgContent]="false"
            [optionName]="'name'" [optionValue]="'key'"
            [title]="'All Business Name'" [inputAriaLabel]="'All Business Name'" [hideTitleOnInput]="true"
            [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
            (onFilterResult)="onBusinessFilterResult($event)"
            [disabled]="loading" [(ngModel)]="selectedBusinessObj">
          </ap-dropdown>
        <span class="toolbar-btn" (click)="exportToExcel()">
          <span class="Appkit4-icon icon-save-outline"></span>
          <span>Export to Excel</span>
          @if (isLoadingExcel) {
            <i class="fa fa-spin fa-spinner"></i>
          }
        </span>
      </div>
    </div>
  </div>
</div>
@if (showModalViewer) {
  <dst-disc-modal-viewer [rowObject]="activeRow" (afterModalClosed)="afterModalClosed()">
  </dst-disc-modal-viewer>
}
